/*
 * @Author: DT
 * @Date: 2022-07-22 11:06:32
 * @LastEditors: ailin
 * @LastEditTime: 2022-10-13 10:31:13
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/limit/list/limit.js
 */
import { mapGetters, mapActions } from "vuex";
import { types as Home } from "@/store/home";
import { types as Vi } from "@/store/vi";
import location from "@/components/location.vue";
import goodsType from "@/components/goodsType.vue";
import { getCookie } from "@/libs/common.js";
import {
  adCart,
  SecKillGood,
  acvtivityInfo,
} from "@/libs/api.js";
const getters = mapGetters({
  getCurrentCity: Home.CURRENT_CITY,
  getCurrentAdCode: Home.AD_CODE,
  getCurrentCityByMin: Home.CURRENT_CITY_MIN,
  getCurrentAdCodeByMin: Home.AD_CODE_MIN,
});
const actions = mapActions({
  setPioltCity: Home.IS_PIOLICity,
  setCartNumber: Home.CART_NUMBER,
  getGoodsDetail: Vi.GOODS_DETAIL,
});
export default {
  name: "Home",
  components: { location, goodsType },
  data() {
    return {
      store_id: "", //同vi页面值
      secKillTime: [], //秒杀商品时间点
      seckillIndex: 0, //秒杀显示
      nowTime: 0, //当前时间
      discountThemeCode: "", //限时抢购主题code
      prodItems: false,
      popData: {
        listName: "",
        price: "",
        mkPrice: "",
        colors: [],
        sellNum: 12, // 接口数据缺失
        prodCount: 1, //起购数量  //接口数据缺失
        minNum: 1, // 接口数据缺失
        defItemId: "",
      },
      popActive: 0,
      sizeActive: 0,
      limit: false,
      storage: 100,
      isMin:false,
      ylyx_commodity_current_price:'',
      ylyx_commodity_original_price:'',
      isShowTitle:true
    };
  },
  computed: {
    ...getters,
  },
  methods: {
    ...actions,
    // 获取主题code
    getAcvtivityInfo(curCityCode) {
      acvtivityInfo(curCityCode).then(
        (res) => {
          if (res.code == "0000") {
            this.discountThemeCode = res.data.discountThemeCode;
            // 获取秒杀列表
            if (res.data.discountThemeCode) this.getSecKillGood();
          }
        },
        () => {
          // console.log('接口出错')
        }
      );
    },
    // 秒杀商品
    getSecKillGood() {
      const params = {
        themeCode: this.discountThemeCode,
        activitySize: 5,
        itemSize: 12,
        deliveryAreaId:getCookie("deliveryAreaId") || ''
      };
      console.log('秒杀参数====',params)
      SecKillGood(params).then(
        (res) => {
          if (res.code == "0000" && res.content) {
            res.content.forEach((item, index) => {
              let satrt = new Date(item.startTime.replace(/-/g, "/")).getTime(),
                end = new Date(item.endTime.replace(/-/g, "/")).getTime();
              if (this.nowTime < satrt) {
                //开始时间大于当前时间 未开始
                item.className = "before";
                item.status = "待开抢";
              }
              if (this.nowTime >= satrt && this.nowTime < end) {
                //开始时间小于当前时间并且结束时间大于当前时间 进行中
                item.className = "ing";
                item.status = "抢购中";
                item.show = true;
                this.seckillIndex = index;
              }
              if (this.nowTime > satrt && this.nowTime >= end) {
                //已结束
                item.className = "over";
                item.status = "已结束";
              }
              this.secKillTime.push({
                satrt: satrt,
                startTime: item.startTime.split(" ")[1].slice(0, 5),
                startDate:this.$moment(item.startTime).format("MM.DD"),
                itemList: item.itemList,
                className: item.className,
                status: item.status,
                show: item.show,
              });
            });
            this.secKillTime.sort((n1, n2) => {
              return n1.satrt - n2.satrt;
            });
            console.log("secKillTime====", this.secKillTime);
          }
          // console.log(res, '限时秒杀')
        },
        () => {
          // console.log('接口错误')
        }
      );
    },
    // 点击显示秒杀
    chooseSec(index) {
      this.seckillIndex = index;
    },
    // 加入购物车弹层
    popCart(listId, isNoStart) {
      if (isNoStart) {
        this.$toast("活动未开始");
        return false;
      }
      // 获取商品信息
      this.getGoodsDetail(listId).then((res) => {
        this.popData = Object.assign(this.popData, res);
        // 图片处理
        if (~this.popData.imgUrl.indexOf("http://")) {
          this.popData.imgUrl = this.popData.imgUrl.replace(
            "http://",
            "https://"
          );
        }
        this.storage = this.popData.colors[0].items[0].itemStorage;
        if (this.popData.limitWay == 0 || this.popData.limitWay > 7) {
          //不限购
          this.popData.prodCount = 1;
          this.popData.minNum = this.popData.limitNum;
        } else if (this.popData.limitWay == 4) {
          // 起售
          this.popData.minNum = this.popData.limitNum;
        }
        this.popData.colors.map((item, index) => {
          item.items.map((sItem, sindex) => {
            if (sItem.itemId == this.popData.defItemId) {
              this.popActive = index;
              this.sizeActive = sindex;
              this.popData.sharePrice =
                sItem.membershipPrice || sItem.itemSalPrice;
            }
          });
        });
        this.prodItems = true;
      });
    },
    // 切换颜色
    changColor(index, itemId, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.popActive = index;
      }
      if (this.sizeActive >= this.popData.colors[index]["items"].length) {
        this.sizeActive = this.popData.colors[index]["items"].length - 1;
        this.popData.defItemId = this.popData.colors[index]["items"][
          this.sizeActive
        ].itemId;
      }
      this.popData.defItemId = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemId;
      this.storage = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemStorage;
      //this.maxPrice、this.price 如果有一品多价也在此处处理
      this.popData.sharePrice =
        this.popData.colors[index]["items"][this.sizeActive].membershipPrice ||
        this.popData.colors[index]["items"][this.sizeActive].itemSalPrice;
      this.popData.marketPrice = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemMarketPrice;
    },
    // 切换规格
    changSize(index, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.sizeActive = index;
        this.popData.defItemId = e.target.getAttribute("itemId");
        this.storage = e.target.getAttribute("storage");
        //this.maxPrice、this.price 如果有一品多价也在此处处理
        this.popData.sharePrice =
          this.popData.colors[this.popActive]["items"][index].membershipPrice ||
          this.popData.colors[this.popActive]["items"][index].itemSalPrice;
        this.popData.marketPrice = this.popData.colors[this.popActive]["items"][
          index
        ].itemMarketPrice;
        this.ylyx_commodity_current_price = this.popData.colors[this.popActive]["items"][index].itemSalPrice;
        this.ylyx_commodity_original_price = this.popData.colors[this.popActive]["items"][index].itemMarketPrice;
        if (this.limit) {
          // 商品有限购
          if (Number(this.popData.limitNum) > Number(this.storage)) {
            //限购数量超出库存时取最小
            this.popData.limitNum = this.storage;
          } else {
            // this.limitNum = limitNum
          }
        } else {
          this.storage = e.target.getAttribute("storage");
          if (Number(this.popData.minNum) > Number(this.storage)) {
            // 最少购买数大于库存 ,团购商品存在这个问题
            this.$toast("商品已售罄");
            this.prodCount = this.storage;
          }
        }
      }
      if (Number(this.prodCount) > Number(this.storage)) {
        this.popData.prodCount = this.storage;
      }
    },
    // 加入购物车
    addCart(item, isNoStart) {
      console.log("item", item, "isNoStart", isNoStart);
      if (isNoStart) {
        this.$toast("活动未开始");
        return false;
      }
      let data = {
        listId: item.listId || item.listingId,
        itemId: this.popData.defItemId || this.popData.itemId,
        itemCount: this.popData.prodCount,
        yxdId: this.store_id, //用户id
        cartType:'12',
        deliveryAreaId:getCookie("deliveryAreaId") || ''
      };
      console.log('加入购物车参数====',data)
      adCart(data, "jsonCallback").then((res) => {
        if (res.returnCode === "0000" || res.code === "0000") {
          console.log(res, "加入购物车");
          this.prodItems = false;
          this.setCartNumber(res.data);
        }
        this.$toast(res.returnMessage);
      });
      //神策埋点
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_AddCart', {
        ylyx_commodity_sku_code: this.popData.defItemId || this.popData.itemId,
        ylyx_commodity_name: this.popData.listName || '',
        ylyx_commodity_original_price: this.ylyx_commodity_original_price || this.popData.marketPrice,
        ylyx_commodity_current_price: this.ylyx_commodity_current_price || this.popData.sharePrice,
        item_id: item.listId || item.listingId,
        ylyx_commodity_count: this.popData.prodCount,
      });
    },
    // 商品详情页跳转
    viPage(listId) {
      console.log('参数参数参数参数参数',this.$route.query)
      // H5
      if (this.$route.query.name) {
        this.$router.push({
          path: "/item/itemPage/" + listId,
          query: { name: this.$route.query.name, latng: this.$route.query.latng, addr: this.$route.query.addr, city: this.$route.query.city, module: this.$route.query.module,freshActType:this.freshActType },
        });
      } else {
        this.$router.push({
          path: "/item/itemPage/" + listId,
          query: {freshActType:this.freshActType,pageFrome:'limit' }
        });
      }
    },
  },
  mounted() {
    if (this.$browser().miniprogram || this.$browser().ulemax) {
      this.isMin = true;
    }
    if(this.$browser().ylxdsq){
      this.isShowTitle  = false;
    }
    if (this.$browser().ylxdsq || this.$browser().ulemax) {
      window.dsBridge &&
        window.dsBridge.call("setNativeTitle", {
          title: "限时秒杀",
        });
    }
    this.nowTime = new Date().getTime();
    this.store_id =
      this.$route.query.store_id ||
      this.$route.query.storeid ||
      this.getStorage("user", "user.STORE_ID") ||
      "";
    if (~(this.store_id + "").indexOf("=")) {
      //处理已产生的store_id 带等号的问题
      this.store_id = this.store_id.split("=")[1];
    }
    if (this.store_id === "false") {
      //处理已产生的store_id 等于'false' 的问题
      this.store_id = "";
    }
    if(this.$route.query.themeActCode){
      console.log('地址上带主题code')
      this.discountThemeCode = this.$route.query.themeActCode;
      this.getSecKillGood();
    }else{
      console.log('地址上没有带主题code')
      this.getAcvtivityInfo(this.$route.query.curCityCode);
    }
  },
};
